import Reflux from 'reflux';

export default Reflux.createActions([
  'slideNavigate',
  'selectLanguage',
  'scrub',
  'closedCaption',
  'transcriptOpen',
  'commentsOpen',
  'transcriptClose',
  'commentsClose',
  'socialMedia',
  'selectVideo',
  'internalLink',
  'externalLink',
  'showMore',
  'showLess',
  'routeChange',
  'sectionScrollView'
]);



/** WEBPACK FOOTER **
 ** ./modules/actions/tracking_actions.js
 **/